// Import our custom CSS
import '../scss/styles.scss'
import u from './help/util'
import { externalLinks } from './shared'
import { Collapse } from 'bootstrap'

//u.CSSLink('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css')


async function loadUserStatus (){
    try {
        const response = await fetch(`${TXT.web_root}/${TXT.language}/user/user_status`);
        if (response.ok) {
            const txt = await response.text();
            u.q('#user_status_placeholder')[0].outerHTML = txt
            let el_user_status = u.q('#user_status_q');
            let user_id = 0;
            if (el_user_status.length){
                // user is logged in
                user_id = el_user_status[0].dataset.uid;
                TXT['userStatus'] = true;
            }else{
                // user is not logged in
                TXT['userStatus'] = false;
            }

            TXT['user_id'] = user_id;
            if ('userStatusCallbacks' in TXT){
                TXT['userStatusCallbacks'].forEach((f)=>{f(TXT['userStatus'], user_id)});
            }
        }
    } catch(err) {
        console.trace('Fetch error:' + err);
    } finally {
        u.q('.user-status-container')[0].classList.remove('opacity-0')
        u.clickHandlers({
            "logoutButton" : function(e){
                let logoutMessage="Are you sure you want to log out?"
                if (confirm(logoutMessage)){
                    window.location = this.href;
                }
            }
        });
    }
};


const darkMode = () =>{
    let isDark = localStorage.getItem('darkmode');
    const darkButton = u.q('#darkModeCheck')[0];
    const turnOff = () => {
        localStorage.setItem('darkmode',0)
        document.documentElement.setAttribute('data-bs-theme', 'light')
    }

    const turnOn = () => {
        localStorage.setItem('darkmode',1)
        document.documentElement.setAttribute('data-bs-theme', 'dark')
    }

    const changeListen = function(){
        darkButton.checked ? turnOn() : turnOff();
    }

    darkButton.checked = isDark  == '1' ? true : false;
    changeListen()
    u.listen(darkButton,'change', changeListen)
};

darkMode();
loadUserStatus();
externalLinks();

// scroll button
(function () {
    const scrollToTopBtns = u.q('#scrollToTopBtn')
    if (scrollToTopBtns.length) {
      const scrollToTopBtn = scrollToTopBtns[0]
      scrollToTopBtn.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      })

      document.addEventListener('scroll', function () {
        if (window.pageYOffset > 500) {
          scrollToTopBtn.classList.add('showBtn')
        } else {
          scrollToTopBtn.classList.remove('showBtn')
        }
      })
    }
})();

u.bodyClassCallbacks({
    'home-page':function(){
        import ("./home" ).then(({home})=>{
            home();
        })
    },
    'content-page':function(){
        import ("./content_page" ).then(({contentPage})=>{
            contentPage();
        });
    },
    'news-page':function(){
        import ("./news_page" ).then(({newsPage})=>{
            newsPage();
        });
    },
    'item-page':function(){
        import ("./item" ).then(({item})=>{
            item();
        });
    },
    'collections-page':function(){
        import ("./collections_page" ).then(({collectionsPage})=>{
            collectionsPage();
        });
    },
    'Search':function(){
        import ("./search" ).then(({search})=>{
            search();
        })
    },
    'User':function(){
        import ("./user" ).then(({user})=>{
            user();
        })
    },
    'ItemForm':function(){
        import ("./itemform" ).then(({itemform})=>{
            itemform();
        })
    },
    'Comments':function(){
        import ("./comments" ).then(({comments})=>{
            comments();
        })
    },
    'CommentForm':function(){
        import ("./commentform" ).then(({commentform})=>{
            commentform();
        })
    },
    'Message_list':function(){
        import ("./message_list" ).then(({message_list})=>{
            message_list();
        })
    },
    'Contact_page':function(){
        import ("./contactform" ).then(({contactform})=>{
            contactform();
        })
    },
    'User_management':function(){
        import ("./user_management" ).then(({user_management})=>{
            user_management();
        })
    }
});
